import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Ellipse, Path } from "react-native-svg";

export const IconIcebowl: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconIcebowl"><Ellipse cx="12" cy="8.5" rx="10.5" ry="4.5" stroke="currentColor"/><Path d="M22.5 8.5V9.54545C22.5 15.3193 17.799 20 12 20C6.20101 20 1.5 15.3193 1.5 9.54545V8.5" stroke="currentColor"/><Path d="M9.5 8L11.5 7M6 7.5L7 9M12.5 9.25L14.5 9.75M16 7.5L17.5 8.5" stroke="currentColor" strokeWidth="1.75"/></CentralIconBase>;
});

export default IconIcebowl;
